import AuctionInsights from '../pages/campaigns/insights/auctionInsights'
import CreateInsights from '../pages/campaigns/insights/creativeInsights'
import GeoDemoInsights from '../pages/campaigns/insights/geoDemoInsights'
import TargetingInsights from '../pages/campaigns/insights/targetingInsights'
import MetaDashboard from '../pages/campaigns/insights/metaDashboard'

export const CampaignInsights =  [
    {
        path: ':id/auction-insights',
        element: <AuctionInsights />
    },
    {
        path: ':id/creative-insights',
        element: <CreateInsights />
    },
    {
        path: ':id/geo-demo-insights',
        element: <GeoDemoInsights />
    },
    {
        path: ':id/targeting-insights',
        element: <TargetingInsights />
    },
    {
        path: ':id/meta-dashboard',
        element: <MetaDashboard />
    },

]

export default CampaignInsights